
import HeroSection from "@/components/home/HeroSection";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import BannerAdsDisplay from "@/components/banner/BannerAdsDisplay";
import ScrollToTop from "@/components/ScrollToTop";
import DynamicMetaTags from "@/components/meta/DynamicMetaTags";
import HowItWorksSection from "@/components/HowItWorksSection";
import { Suspense } from "react";
import { LazyFallback } from "@/components/lazy/LazyAdminComponents";
import { 
  LazyFeaturedBusinesses,
  LazyWhyTrustUsSection,
  LazySignUpSection,
  LazySuggestBusinessButton,
  LazyAdSnippetsDisplay,
  LazyHomeFallback
} from "@/components/lazy/LazyHomeComponents";

export default function Index() {
  return (
    <div className="min-h-screen flex flex-col">
      <DynamicMetaTags />
      <Header />
      <main className="flex-1">
        <BannerAdsDisplay />
        <HeroSection />
        <HowItWorksSection />
        <Suspense fallback={null}>
          <LazyFeaturedBusinesses />
          <LazySuggestBusinessButton />
          <LazyAdSnippetsDisplay />
          <LazyWhyTrustUsSection />
          <LazySignUpSection />
        </Suspense>
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}
